import React, { Component } from 'react';
import { NumericInput, Checkbox, FileInput } from '@blueprintjs/core';
import { DateInput } from '@blueprintjs/datetime';
import moment from 'moment';

class RenderInput extends Component {
    render() {
        const { value, name, autoFocus, label, type, datePicker } = this.props;
        return (
            <div className="flex-column">
                { type === 'checkbox' ?
                    <Checkbox checked={value} label={label} onChange={() => this.props.onChangeHandler({ text: !value , value: name })} /> :
                    <label className="pt-label">
                        { label }
                        { datePicker ?
                            <DateInput
                                minDate={moment("1900-01-01").toDate()}
                                formatDate={date => moment(date).format(this.props.dateFormat ? this.props.dateFormat : 'ddd, MMM Do, YYYY')}
                                onChange={date => this.props.onChangeHandler({ text: date, value: name })}
                                value={value ? new Date(value) : new Date()}
                                closeOnSelection={true}
                                parseDate={str => new Date(str)} /> :
                            type === 'numeric' ?
                                <NumericInput placeholder="Enter a number..."
                                    className="pt-fill"
                                    value={value}
                                    min={0}
                                    onValueChange={(number, numberInString) => this.props.onChangeHandler({ text: numberInString, value: name })} /> :
                                type === 'textarea' ?
                                    <textarea style={{resize: 'none'}} className="pt-input pt-fill"
                                        autoFocus={autoFocus}
                                        value={value ? value : ''}
                                        onChange={event => this.props.onChangeHandler({ text: event.target.value, value: name })}
                                        onKeyDown={this.onKeyDown}
                                        rows="5"
                                        type="text"
                                        dir="auto" /> :
                                    type === 'select' ?
                                        <div className="pt-select">
                                            <select value={value} onChange={event => this.props.onChangeHandler({ text: event.target.value, value: name })}>
                                                { this.props.items.map((v, i) => (<option key={i} value={v}>{v}</option>))}
                                            </select>
                                        </div> :
                                        type === 'upload' ?
                                            <FileInput fill
                                                text={value ? value : 'Choose file...'}
                                                onChange={event => this.props.onChangeHandler({ file: event.target.files, value: name })} /> :
                                            <input className="pt-input pt-fill"
                                                autoFocus={autoFocus}
                                                onKeyDown={this.onKeyDown}
                                                value={value ? value : ''}
                                                onChange={event => this.props.onChangeHandler({ text: event.target.value, value: name })}
                                                type="text"
                                                dir="auto" />
                        }
                    </label>
                }
            </div>
        );
    }
}

class RenderDatePicker extends Component {
    render() {
        const { value, name } = this.props;

        return (
            <DateInput
                formatDate={date => moment(date).format(this.props.dateFormat ? this.props.dateFormat : 'ddd, MMM Do, YYYY')}
                onChange={date => this.props.onChangeHandler({ text: date, value: name })}
                value={value ? new Date(value) : new Date()}
                closeOnSelection={true}
                canClearSelection={false}
                parseDate={str => new Date(str)}
            />
        )
    }
}
export { RenderInput, RenderDatePicker };



// WEBPACK FOOTER //
// ./src/components/main/dashboard/modals/Base.jsx